export const MAX_PHOTO_FILE_SIZE = 25000000 // 25MB
